<div [class.is-fullscreen]="isFullscreen" class="fab-actions">
    <layout-fab-sub-tools
        *ngIf="!isEcgReportingDetail && _showCustomMeasuresButton && showLeadsAnnotationsButton"
        [estensaIcon]="'icon_misure'"
        tooltip="{{ 'MEASURES' | translate }}"
    >
        <mat-button-toggle-group
            (click)="onSelectedMeasures()"
            [(ngModel)]="selectedMeasures"
            class="se-sub-options"
            multiple
        >
            <mat-button-toggle *ngIf="_showCustomMeasuresButton" mat-button value="global"
                >{{ "GLOBAL_ANNOTATIONS" | translate }}
            </mat-button-toggle>
            <mat-button-toggle *ngIf="showLeadsAnnotationsButton" mat-button value="lead"
                >{{ "LEADS_ANNOTATIONS" | translate }}
            </mat-button-toggle>
        </mat-button-toggle-group>
    </layout-fab-sub-tools>

    <layout-fab-sub-tools
        (click)="onLeadsAnnotationsToggle()"
        *ngIf="
            (!_showCustomMeasuresButton && showLeadsAnnotationsButton) ||
            (isEcgReportingDetail && showLeadsAnnotationsButton)
        "
        [estensaIcon]="'icon_misure'"
        tooltip="{{ 'LEADS_ANNOTATIONS' | translate }}"
    >
    </layout-fab-sub-tools>

    <layout-fab-sub-tools
        (click)="onGlobalAnnotationsToggle()"
        *ngIf="!isEcgReportingDetail && _showCustomMeasuresButton && !showLeadsAnnotationsButton"
        [estensaIcon]="'icon_misure'"
        tooltip="{{ 'GLOBAL_ANNOTATIONS' | translate }}"
    >
    </layout-fab-sub-tools>

    <div *ngIf="!isShowingLeads" class="fab-content">
        <button
            (click)="isFabOpen = !isFabOpen"
            class="fab-expander"
            mat-mini-fab
            matTooltip="{{ 'Tools' | translate }}"
            matTooltipClass="mat-tooltip-bigger"
            matTooltipPosition="left"
            matTooltipShowDelay="500"
        >
            <mat-icon *ngIf="!isFabOpen">more_vert</mat-icon>
            <mat-icon *ngIf="isFabOpen">close</mat-icon>
        </button>
    </div>
    <div *ngIf="isFabOpen && !isShowingLeads" class="fab-tools">
        <layout-fab-sub-tools
            (actionClick)="onFullscreenChange()"
            [estensaIcon]="isFullscreen ? 'icon_fit_to_screen' : 'icon_full_screen'"
            [smallFontEnabled]="true"
            tooltip="{{ 'FullScreen' | translate }}"
        >
        </layout-fab-sub-tools>
        <layout-fab-sub-tools
            (actionClick)="onSelectedArrangement()"
            [estensaIcon]="'icon_disposizione'"
            tooltip="{{ 'ARRANGEMENT' | translate }}"
        >
            <mat-button-toggle-group [(ngModel)]="selectedArrangementValue" class="se-sub-options">
                <mat-button-toggle *ngFor="let arrangement of arrangements" [value]="arrangement.value" mat-button>
                    {{ arrangement.key }}
                </mat-button-toggle>
            </mat-button-toggle-group>
        </layout-fab-sub-tools>
        <layout-fab-sub-tools
            (actionClick)="onSelectedFormat()"
            [estensaIcon]="'icon_formato'"
            tooltip="{{ 'FORMAT' | translate }}"
        >
            <mat-button-toggle-group [(ngModel)]="selectedFormat" class="se-sub-options">
                <mat-button-toggle [value]="0" mat-button>{{ "Standard" | translate }}</mat-button-toggle>
                <mat-button-toggle [value]="1" mat-button>{{ "Cabrera" | translate }}</mat-button-toggle>
            </mat-button-toggle-group>
        </layout-fab-sub-tools>
        <layout-fab-sub-tools
            (actionClick)="onSelectedTimeAlignment()"
            [actionIcon]="'icon_allineamento_temporale'"
            tooltip="{{ 'TEMPORAL_ALIGN' | translate }}"
        >
            <mat-button-toggle-group [(ngModel)]="selectedTimeAlignment" class="se-sub-options">
                <mat-button-toggle [value]="0" mat-button>{{ "SEQUENTIAL" | translate }}</mat-button-toggle>
                <mat-button-toggle [value]="1" mat-button>{{ "SIMULTANEOUS" | translate }}</mat-button-toggle>
            </mat-button-toggle-group>
        </layout-fab-sub-tools>
        <layout-fab-sub-tools
            (actionClick)="onSelectedPaperRate()"
            [estensaIcon]="'icon_velocita_carta_millimetrata'"
            tooltip="{{ 'PAPER_RATE' | translate }}"
        >
            <mat-button-toggle-group [(ngModel)]="selectedPaperRate" class="se-sub-options">
                <mat-button-toggle [value]="0" mat-button>{{ "25mm" | translate }}</mat-button-toggle>
                <mat-button-toggle [value]="1" mat-button>{{ "50mm" | translate }}</mat-button-toggle>
            </mat-button-toggle-group>
        </layout-fab-sub-tools>
        <layout-fab-sub-tools [estensaIcon]="'icon_opacita_carta'" tooltip="{{ 'PAPER_OPACITY' | translate }}">
            <se-fab-slider [(ngModel)]="paperOpacity" labelFactor="10" max="1" min="0" step="0.1"></se-fab-slider>
        </layout-fab-sub-tools>
        <layout-fab-sub-tools [estensaIcon]="'icon_spaziatura_tracce'" tooltip="{{ 'TRACE_SPACING' | translate }}">
            <se-fab-slider
                [(ngModel)]="traceSpacing"
                decreaseIcon="keyboard_arrow_down"
                increaseIcon="keyboard_arrow_up"
                labelFactor="100"
                max="0.3"
                min="0"
                step="0.01"
            ></se-fab-slider>
        </layout-fab-sub-tools>
        <layout-fab-sub-tools
            *ngIf="visualComparison"
            [estensaIcon]="'icon_icon_distanza_tracce'"
            tooltip="{{ 'STUDIES_SPACING' | translate }}"
        >
            <se-fab-slider
                [(ngModel)]="studySpacing"
                decreaseIcon="keyboard_arrow_down"
                increaseIcon="keyboard_arrow_up"
                labelFactor="100"
                max="2"
                min="-1"
                step="0.01"
            ></se-fab-slider>
        </layout-fab-sub-tools>

        <layout-fab-sub-tools
            *ngIf="isHorizontalSpacingEnabled()"
            [actionIcon]="'icon_distanza_tracce_orizzontale'"
            tooltip="{{ 'HORIZONTAL_STUDIES_SPACING' | translate }}"
        >
            <se-fab-slider
                [(ngModel)]="horizontalStudySpacing"
                decreaseIcon="keyboard_arrow_down"
                increaseIcon="keyboard_arrow_up"
                labelFactor="100"
                max="2.75"
                min="-1"
                step="0.01"
            ></se-fab-slider>
        </layout-fab-sub-tools>
        <layout-fab-sub-tools
            (actionClick)="onSelectedGuidedComparison()"
            *ngIf="visualComparison"
            [estensaIcon]="'icon_VC_guidata'"
            tooltip="{{ 'ECG_guidedVC' | translate }}"
        >
            <mat-button-toggle-group [(ngModel)]="selectedGuidedComparisonValue" class="se-sub-options">
                <mat-button-toggle
                    *ngFor="let guidedComparison of guidedComparisons"
                    [value]="guidedComparison.value"
                    mat-button
                >
                    {{ guidedComparison.key }}
                </mat-button-toggle>
            </mat-button-toggle-group>
        </layout-fab-sub-tools>
        <layout-fab-sub-tools
            (actionClick)="onCaliperMode()"
            [estensaIcon]="'icon_ruler'"
            tooltip="{{ 'CALIPER' | translate }}"
        >
            <mat-button-toggle-group [(ngModel)]="caliperMode" class="se-sub-options">
                <mat-button-toggle [value]="0" mat-button>{{ "SINGLE_CALIPER" | translate }}</mat-button-toggle>
                <mat-button-toggle [value]="1" mat-button>{{ "MULTI_CALIPER" | translate }}</mat-button-toggle>
            </mat-button-toggle-group>
        </layout-fab-sub-tools>
        <layout-fab-sub-tools
            (actionClick)="onFiducialPoints()"
            [actionIcon]="'icon_punti_fiduciali'"
            tooltip="{{ 'FIDUCIAL_POINTS' | translate }}"
        >
            <mat-button-toggle-group [(ngModel)]="fiducialPointsVisible" class="se-sub-options">
                <mat-button-toggle [value]="true" mat-button
                    >{{ "SHOW_FIDUCIAL_POINTS" | translate }}
                </mat-button-toggle>
                <mat-button-toggle [value]="false" mat-button
                    >{{ "HIDE_FIDUCIAL_POINTS" | translate }}
                </mat-button-toggle>
            </mat-button-toggle-group>
        </layout-fab-sub-tools>
        <layout-fab-sub-tools
            (actionClick)="onFit()"
            [enableEstensaFontSet]="false"
            [estensaIcon]="'settings_overscan'"
            tooltip="{{ 'FIT' | translate }}"
        ></layout-fab-sub-tools>
        <layout-fab-sub-tools
            [enableEstensaFontSet]="false"
            [estensaIcon]="'zoom_in'"
            tooltip="{{ 'ZOOM' | translate }}"
        >
            <se-fab-slider [(ngModel)]="zoomFactor" max="10" min="1" step="0.09"></se-fab-slider>
        </layout-fab-sub-tools>
        <layout-fab-sub-tools
            (actionClick)="onCustomCommand()"
            *ngIf="customCommandState.visible"
            [enableEstensaFontSet]="false"
            [estensaIcon]="'print'"
            [matTooltip]="customCommandState.text"
        >
        </layout-fab-sub-tools>
        <layout-fab-sub-tools
            (actionClick)="onLowFilterChange()"
            *ngIf="enableSchillerFilters"
            [estensaIcon]="'icon_filtro_rumore_1'"
            tooltip="{{ 'LowFilter' | translate }}"
        >
            <mat-button-toggle-group
                (change)="onLowFilterChange($event.value)"
                [(ngModel)]="lowFilter"
                class="se-sub-options"
            >
                <mat-button-toggle
                    *ngFor="let filter of schillerFiltersConfiguration.lowFilters"
                    [value]="filter"
                    mat-button
                >
                    <ng-container *ngIf="!filter">{{ "NoFilter" | translate }}</ng-container>
                    <ng-container *ngIf="filter">{{ filter }} Hz</ng-container>
                </mat-button-toggle>
            </mat-button-toggle-group>
        </layout-fab-sub-tools>
        <layout-fab-sub-tools
            (actionClick)="onPrintAsDisplayed()"
            *ngIf="enabledPrintAsDisplayed"
            [enableEstensaFontSet]="false"
            [estensaIcon]="'picture_as_pdf'"
            tooltip="{{ 'PrintSettings' | translate }}"
        >
            <mat-button-toggle-group [(ngModel)]="printAsDisplayed" class="se-sub-options">
                <mat-button-toggle [value]="false" mat-button>{{ "Standard" | translate }}</mat-button-toggle>
                <mat-button-toggle [value]="true" mat-button>{{ "PrintAsDisplayed" | translate }}</mat-button-toggle>
            </mat-button-toggle-group>
        </layout-fab-sub-tools>
    </div>
</div>
